import React from "react";
import moreSrc from "../../assets/svgs/more_vert-24px.svg";
import menuSrc from "../../assets/svgs/menu-24px.svg";
import calendarSrc from "../../assets/svgs/calendar_today-24px.svg";
import libraryAddSrc from "../../assets/svgs/library_add-24px.svg";
import mapLayersSrc from "../../assets/svgs/layers-24px.svg";
import mapLayersClearSrc from "../../assets/svgs/layers_clear-24px.svg";

export const MoreIcon = () => <img src={moreSrc} />;
export const MenuIcon = () => <img src={menuSrc} />;
export const CalendarIcon = () => <img src={calendarSrc} />;
export const LibraryAddIcon = () => <img src={libraryAddSrc} />;
export const MapLayersIcon = () => <img src={mapLayersSrc} />;
export const MapLayersClearIcon = () => <img src={mapLayersClearSrc} />;
